import React from 'react';

import FileCard from '@components/Files/FileCard.web';
import { Box } from '@components/Restyle';
import GlobalSearchList from '@components/Search/GlobalSearchList.web';
import { FileRowSkeleton } from '@components/shared/skeletons';
import { Document } from '@graphql/generated';
import { Search } from '@root/types';

interface IDocumentSearch {
  search: string;
  data: Search<Document>[];
  loading?: boolean;
  sectionFooter?: JSX.Element;
  filterPart?: JSX.Element;
  hasError?: boolean;
  onPress?: (item: Document) => void;
  onEndReached?: (info: { distanceFromEnd: number }) => void;
}

const renderFileRowSkeleton = (index: number) => (
  <FileRowSkeleton key={index} />
);

const FilesSearch: React.FC<IDocumentSearch> = ({
  search,
  data,
  loading = false,
  sectionFooter,
  filterPart,
  hasError = false,
  onPress,
  onEndReached,
}) => {
  return (
    <GlobalSearchList
      onEndReached={onEndReached}
      search={search}
      loading={loading}
      isViewAllContacts={false}
      onPress={() => {}}
      hasError={hasError}
      skeletonRow={renderFileRowSkeleton}
      lists={[
        {
          title: 'Files',
          data: data,
          headerLeft: filterPart,
          totalCount: data.length > 0 ? data[0].total : data.length,
          render: (item) => {
            const document = item.record as Document;

            return (
              <FileCard
                filterVal={search}
                document={document}
                onPress={() => {
                  onPress?.(document);
                }}
              />
            );
          },
          itemSeparatorComponent: <Box marginBottom='l' />,
          sectionHeaderMarginBottom: 'xs',
          sectionFooter: sectionFooter,
        },
      ]}
    />
  );
};

export default FilesSearch;
